import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FileUploadAwareJsonWriterClass;
function FileUploadAwareJsonWriter() {
  if (FileUploadAwareJsonWriterClass === VOID) {
    class $ {
      constructor(wrappedWriter) {
        this.n47_1 = wrappedWriter;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.o47_1 = LinkedHashMap().ec();
      }
      p47() {
        return this.o47_1;
      }
      o3y() {
        // Inline function 'kotlin.apply' call
        this.n47_1.o3y();
        return this;
      }
      p3y() {
        // Inline function 'kotlin.apply' call
        this.n47_1.p3y();
        return this;
      }
      g3y() {
        // Inline function 'kotlin.apply' call
        this.n47_1.g3y();
        return this;
      }
      h3y() {
        // Inline function 'kotlin.apply' call
        this.n47_1.h3y();
        return this;
      }
      o4a(name) {
        // Inline function 'kotlin.apply' call
        this.n47_1.o4a(name);
        return this;
      }
      v3y(value) {
        // Inline function 'kotlin.apply' call
        this.n47_1.v3y(value);
        return this;
      }
      f3z(value) {
        // Inline function 'kotlin.apply' call
        this.n47_1.f3z(value);
        return this;
      }
      a3z(value) {
        // Inline function 'kotlin.apply' call
        this.n47_1.a3z(value);
        return this;
      }
      x3y(value) {
        // Inline function 'kotlin.apply' call
        this.n47_1.x3y(value);
        return this;
      }
      d3z(value) {
        // Inline function 'kotlin.apply' call
        this.n47_1.d3z(value);
        return this;
      }
      q4a(value) {
        // Inline function 'kotlin.apply' call
        this.n47_1.q4a(value);
        return this;
      }
      k3z(value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.o47_1;
        // Inline function 'kotlin.collections.set' call
        var key = this.n47_1.e4a();
        tmp0.a5(key, value);
        this.n47_1.z3x();
        return this;
      }
      z3x() {
        // Inline function 'kotlin.apply' call
        this.n47_1.z3x();
        return this;
      }
      e4a() {
        return this.n47_1.e4a();
      }
      l6() {
        this.n47_1.l6();
      }
    }
    initMetadataForClass($, 'FileUploadAwareJsonWriter');
    FileUploadAwareJsonWriterClass = $;
  }
  return FileUploadAwareJsonWriterClass;
}
//region block: exports
export {
  FileUploadAwareJsonWriter as FileUploadAwareJsonWriter1mx337tg0y9oj,
};
//endregion

//# sourceMappingURL=FileUploadAwareJsonWriter.mjs.map
